import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6720ca74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-pdf" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_first_pdf_page = _resolveComponent("first-pdf-page")!
  const _component_second_pdf_page = _resolveComponent("second-pdf-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_first_pdf_page, {
      data: _ctx.data,
      "report-info": _ctx.reportInfo,
      class: "periodontal-pdf__page"
    }, null, 8, ["data", "report-info"]),
    _createVNode(_component_second_pdf_page, {
      bleeding: _ctx.bleeding,
      comments: _ctx.comments,
      "consolidated-data": _ctx.consolidatedData,
      data: _ctx.data,
      plaque: _ctx.plaque,
      pockets: _ctx.pockets,
      "pockets-table": _ctx.pocketsTable,
      class: "periodontal-pdf__page"
    }, null, 8, ["bleeding", "comments", "consolidated-data", "data", "plaque", "pockets", "pockets-table"])
  ]))
}